/* eslint-disable */
export default {
  logging: 'ログ記録中...',
  logCall: '通話のログ記録',
  editLog: 'ログの編集',
  select: '一致するレコードの選択',
  OnHold: '保留中',
  Ringing: '呼び出し中',
  CallConnected: '通話を接続済み',
  unknownUser: '不明なユーザー',
  unknownNumber: '匿名',
  unavailable: '連絡不可',
  viewDetails: '詳細を表示',
  addEntity: '新規作成',
  addLog: 'ログ',
  text: 'テキスト',
  call: '通話',
  missedCall: '不在',
  inboundCall: '着信',
  outboundCall: '発信',
  answeredBy: '応答者',
} as const;

// @key: @#@"logging"@#@ @source: @#@"Logging..."@#@
// @key: @#@"logCall"@#@ @source: @#@"Log Call"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"select"@#@ @source: @#@"Select a matching record"@#@
// @key: @#@"OnHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"Ringing"@#@ @source: @#@"Ringing"@#@
// @key: @#@"CallConnected"@#@ @source: @#@"Call Connected"@#@
// @key: @#@"unknownUser"@#@ @source: @#@"Unknown User"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"unavailable"@#@ @source: @#@"Unavailable"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"addEntity"@#@ @source: @#@"Create New"@#@
// @key: @#@"addLog"@#@ @source: @#@"Log"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
// @key: @#@"missedCall"@#@ @source: @#@"Missed"@#@
// @key: @#@"inboundCall"@#@ @source: @#@"Inbound"@#@
// @key: @#@"outboundCall"@#@ @source: @#@"Outbound"@#@
// @key: @#@"answeredBy"@#@ @source: @#@"Answered by"@#@
